module.exports = __webpack_public_path__ + "1cf2dac6a6a5a4470b83e71d43d4002e.svg";